var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFlash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flash 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.9768 11.2528C20.8466 10.9715 20.638 10.7339 20.3761 10.5683C20.1141 10.4027 19.8099 10.3163 19.5 10.3194H15.9666L17.68 3.3618C17.7711 3.00671 17.7396 2.63127 17.5907 2.2963C17.4418 1.96133 17.1841 1.68643 16.8595 1.51614C16.5349 1.34586 16.1622 1.29014 15.802 1.35803C15.4418 1.42592 15.115 1.61343 14.8746 1.8902L5.2546 13L5.239 13.0156C5.04177 13.254 4.9166 13.5437 4.87815 13.8508C4.8397 14.1578 4.88957 14.4694 5.02192 14.7492C5.15427 15.0289 5.3636 15.265 5.62539 15.43C5.88718 15.595 6.19057 15.6819 6.5 15.6806H10.0334L8.32 22.6382C8.22216 22.997 8.25096 23.3785 8.40156 23.7186C8.55216 24.0586 8.81535 24.3363 9.1468 24.505C9.37971 24.6261 9.63831 24.6894 9.9008 24.6896C10.1364 24.6904 10.3691 24.6387 10.5823 24.5385C10.7954 24.4382 10.9836 24.2918 11.1332 24.1098L20.7688 12.9818C20.9651 12.7436 21.089 12.4542 21.1259 12.1477C21.1627 11.8413 21.111 11.5307 20.9768 11.2528ZM10.2648 22.3236L11.8508 15.9094C11.9151 15.6692 11.9236 15.4175 11.8756 15.1736C11.8275 14.9297 11.7242 14.7 11.5736 14.5022C11.423 14.3043 11.229 14.1437 11.0067 14.0325C10.7843 13.9212 10.5394 13.8625 10.2908 13.8606H6.9186L15.7352 3.6764L14.1492 10.0906C14.0849 10.3308 14.0764 10.5825 14.1244 10.8264C14.1725 11.0703 14.2758 11.3 14.4264 11.4978C14.577 11.6957 14.771 11.8563 14.9933 11.9675C15.2157 12.0788 15.4606 12.1375 15.7092 12.1394H19.0814L10.2648 22.3236Z",
    fill: "var(--fill-0, white)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFlash);
export default __webpack_public_path__ + "static/media/icon-flash.6234a235e9d730bbadfbf1dac55477ac.svg";
export { ForwardRef as ReactComponent };